import React, { useContext, useEffect, useState } from 'react';
import {
  Col, Table, InputGroup, Form,
} from 'react-bootstrap';
import {
  Card, CardBody, CardTitleWrap, CardTitle,
} from '@/shared/components/Card';
import { TablePagination } from '@mui/material';
import { AuthContext } from '../../../context/AuthContext';
import { Button } from '../../../shared/components/Button';

const LogsTable = () => {
  const { apiGlobal } = useContext(AuthContext);
  const [logsData, setLogsData] = useState([]);
  const [searchStaffName, setSearchStaffName] = useState('');
  const [filteredLogs, setFilteredLogs] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const fetchlogData = async () => {
    try {
      const url = await fetch(`${apiGlobal}update_delete_log_data.php`, {
        method: 'POST',
      });
      const response = await url.json();
      if (response?.status && response?.message === 'Success') {
        setLogsData(response?.data);
        setFilteredLogs(response?.data); // initialize filtered data
      } else {
        console.log(response);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchlogData();
  }, []);

  useEffect(() => {
    const filtered = logsData
    .filter(log => (log?.staff_name ?? '').toLowerCase().includes(searchStaffName.toLowerCase()));
    setFilteredLogs(filtered);
    setPage(0); // reset to first page on filter
  }, [searchStaffName, logsData]);

  return (
    <div>
      {/* Search Filters */}
      <div
        className="mb-4"
        style={{
          padding: '15px',
          borderRadius: '8px',
          backgroundColor: '#f8f9fa',
          display: 'flex',
          justifyContent: 'flex-start',
          gap: '10px',
          alignItems: 'center',
          flexWrap: 'wrap',
        }}
      >
        <h5 className="mb-2" style={{ marginRight: '20px', fontWeight: '600' }}>
          Filter logs
        </h5>

        <InputGroup className="mb-2" style={{ maxWidth: '200px' }}>
          <Form.Control
            type="text"
            placeholder="Search Staff"
            value={searchStaffName}
            onChange={e => setSearchStaffName(e.target.value)}
            style={{
              borderRadius: '25px',
              padding: '8px',
              border: '1px solid #ddd',
            }}
          />
        </InputGroup>

        <Button
          variant="outline-danger"
          style={{
            borderRadius: '25px',
            padding: '8px 16px',
            marginLeft: '10px',
          }}
          onClick={() => setSearchStaffName('')}
        >
          Clear Filters
        </Button>
      </div>

      <Col md={12}>
        <Card>
          <CardBody>
            {/* <CardTitleWrap>
              <CardTitle>Update/Delete logs</CardTitle>
              
            </CardTitleWrap> */}
            <TablePagination
              component="div"
              count={filteredLogs.length}
              page={page}
              onPageChange={(event, newPage) => setPage(newPage)}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={(event) => {
                setRowsPerPage(parseInt(event.target.value, 10));
                setPage(0);
              }}
              rowsPerPageOptions={[5, 10, 20, 50]}
            />
            <Table
              responsive
              striped
              bordered
              hover
              style={{
                backgroundColor: '#f9f9f9',
                borderRadius: '8px',
                boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
              }}
            >
              <thead className="bg-success text-white text-center">
                <tr>
                  <th>#</th>
                  <th>Staff Type</th>
                  <th>Staff Name</th>
                  <th>Type Name</th>
                  <th>Log type name</th>
                  <th>Old Data</th>
                  <th>New Data</th>
                </tr>
              </thead>
              {filteredLogs.length > 0 ? (
                <tbody>
                  {filteredLogs
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((log, index) => (
                      <tr key={log.id || index} className="text-center">
                        <td>{page * rowsPerPage + index + 1}</td>
                        <td>{log?.staff_type}</td>
                        <td>{log?.staff_name}</td>
                        <td>{log?.type_name}</td>
                        <td>{log?.log_type_name}</td>
                        <td>
                          <textarea className="form-control" rows="2" value={log?.log_data_old} readOnly />
                        </td>
                        <td>
                          <textarea className="form-control" rows="2" value={log?.log_data_new} readOnly />
                        </td>
                      </tr>
                    ))}
                </tbody>
              ) : (
                <tbody>
                  <tr>
                    <td colSpan="7" className="text-center text-muted py-4">
                      No log data available to display.
                    </td>
                  </tr>
                </tbody>
              )}
            </Table>

            {/* <TablePagination
              component="div"
              count={filteredLogs.length}
              page={page}
              onPageChange={(event, newPage) => setPage(newPage)}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={(event) => {
                setRowsPerPage(parseInt(event.target.value, 10));
                setPage(0);
              }}
              rowsPerPageOptions={[5, 10, 20, 50]}
            /> */}
          </CardBody>
        </Card>
      </Col>
    </div>
  );
};

export default LogsTable;
